export enum SkeletonElementButtonShape {
  Default = 'default'
}
